export const alertError = (err: any, key?: string) => {
    if (['ustest.yanglee.top', 'localhost', '127.0.0.1'].includes(window.location.hostname)) {
        alert(`${key || 'alert'} => ${JSON.stringify(err)}`)
    }
}
